import React from "react";
import { Radio } from "antd";

const { Button, Group } = Radio;

const OfferTypes = ({ onChangeTypeList, typesList, value }) => {
  return typesList ? (
    <Group onChange={onChangeTypeList} defaultValue={value ? value : "total"}>
      <Button value={"total"}>
        Все:
        {typesList &&
          typesList.find(item => item.key === "total") &&
          typesList.find(item => item.key === "total").count}
      </Button>
      {typesList &&
        typesList.map(item => {
          return item.key !== "total" ? (
            <Button key={item.key} value={item.key} disabled={item.count === 0}>
              {item.name}: {item.count}
            </Button>
          ) : null;
        })}
    </Group>
  ) : null;
};

export default OfferTypes;
